document.addEventListener("cart:updated", (event) => {
  const cart = event.detail.cart;

  fetch(`${theme.routes.home}?section_id=header`)
    .then((res) => res.text())
    .then((data) => {
      const parsedHTML = new DOMParser().parseFromString(data, "text/html");
      const freeShippingBar = parsedHTML.querySelector(".free-shipping-bar");
      const additionalCartItems = parsedHTML.querySelector(
        "[additional-cart-items]"
      );

      document.querySelector(".free-shipping-bar").outerHTML =
        freeShippingBar.outerHTML;

      document.querySelector("[additional-cart-items]").outerHTML =
        additionalCartItems.outerHTML;
    });
});
